"use strict";
// Logical padding-inline-start property evaluator
// Defines the logical inline start padding of an element, adapting to writing mode and direction
// MDN: https://developer.mozilla.org/en-US/docs/Web/CSS/padding-inline-start
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_padding_1 = require('./shared-padding.cjs');
/**
 * Parses CSS padding-inline-start property value
 *
 * Syntax: <length-percentage> | global-keywords
 *
 * @param value - The CSS value to parse
 * @returns Parsed padding-inline-start value or null if invalid
 */
function parse(value) {
    return (0, shared_padding_1.parsePaddingProperty)(value);
}
/**
 * Converts parsed padding-inline-start value back to CSS string
 *
 * @param parsed - The parsed padding-inline-start value
 * @returns CSS string representation or null if invalid
 */
function toCSSValue(parsed) {
    return (0, shared_padding_1.paddingToCSSValue)(parsed);
}
